import { IUpsertPricesData } from "~/api2/camping_styles"
import { PriceConfig } from "~/components/Admin/Settings/pages/pricing/types"
import { PriceProps } from "~/interfaces"
import { validDurations, validElectric } from "~/types"

const isCampingStyleIdInValues = (
  priceConfig: PriceConfig,
  campingStyleId: string
): { isInPriceConfig: boolean, oldConfigKey: string | undefined } => {
  for (const key of Object.keys(priceConfig)) {
    if (key.includes(campingStyleId)) {
      return { isInPriceConfig: true, oldConfigKey: key }
    }
  }

  return { isInPriceConfig: false, oldConfigKey: undefined }
}


const mapPriceConfigToData = (priceConfig: PriceConfig): IUpsertPricesData => {
  const sitePricesMap: { [siteId: string]: { id: string, prices_attributes: Partial<PriceProps>[] } } = {}

  Object.keys(priceConfig).forEach((key) => {
    const prices = priceConfig[key]
    const [duration, electric, amountStr] = key.split('_')
    const amount_in_cents = parseInt(amountStr, 10)
    prices.forEach(({ siteId, id, _destroy }) => {
      if (!sitePricesMap[siteId]) {
        sitePricesMap[siteId] = {
          id: siteId,
          prices_attributes: []
        }
      }

      const price: Partial<PriceProps & { _destroy?: boolean }> = {
        id,
        amount_in_cents,
        duration: duration as validDurations,
        electric: electric as validElectric,
        // TODO: ranges too
        _destroy
      }

      sitePricesMap[siteId].prices_attributes.push(price)
    })
  })

  const sites_attributes = Object.values(sitePricesMap)
  return { sites_attributes }
}

const getGroupKeys = (priceConfig: PriceConfig, duration: validDurations, electric: validElectric) => {
  return Object.keys(priceConfig).filter((configKey) => {
    const [d, e] = configKey.split("_")
    return d === duration && e === electric
  })
}

export {isCampingStyleIdInValues, mapPriceConfigToData, getGroupKeys}

